// extracted by mini-css-extract-plugin
module.exports = {"bill-of-lading":"BillOfLading_bill-of-lading__tqFeJ","container":"BillOfLading_container___SfPk"};